//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'

export default {
  name: 'FaqSection',
  components: {
    ElLottie,
  },
  data() {
    return {
      faqs: [],
      faqAnimation: {
        container: '.faq__img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/faq.json`,
      },
    }
  },
  mounted() {
    this.faqs = this.$getBullets('faqScreenFaqs')
    this.faqs.forEach((item) => {
      item.isActive = false
    })
  },
  methods: {
    toggleFaqElement(index, $event) {
      const element = $event.currentTarget
      const elementContent = element.querySelector('.faq__el-content')
      if (!this.faqs[index].isActive) {
        elementContent.style.maxHeight = elementContent.scrollHeight + 'px'
        element.classList.add('_active')
      } else {
        elementContent.style.maxHeight = 0
        element.classList.remove('_active')
      }
      this.faqs[index].isActive = !this.faqs[index].isActive
    },
  },
}
